import "core-js/stable";
import "regenerator-runtime/runtime";
import 'intersection-observer';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/index';
import 'jquery';
import 'bootstrap';
//import 'animate.css/animate.min.css';

// third party
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCalendarAlt } from "@fortawesome/pro-regular-svg-icons";
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { faGreaterThan } from '@fortawesome/pro-solid-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faWheelchair } from '@fortawesome/pro-regular-svg-icons';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck, faCircleExclamation, faCircleInfo } from "@fortawesome/free-solid-svg-icons";

library.add(faCircle);
library.add(faCalendarAlt);
library.add(faQuestionCircle);
library.add(faEye);
library.add(faEyeSlash);
library.add(faStar);
library.add(faGreaterThan);
library.add(faFacebookF);
library.add(faLinkedinIn);
library.add(faWheelchair);
library.add(faSearch);
library.add(faTimes);
library.add(faCircleCheck);
library.add(faCircleExclamation);

import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome';

const app = createApp(App);

// import configuration from config included via env-config.js
// note: to allow Octopus to inject configuration at deployment, the configuration
//       must *not* be part of what gets bundled by webpack. env-config.js exists
//       in the public folder and is simply copied over to the wwwroot. It is referenced
//       by the index.html and will define the window.__INITIAL_STATE__ global variable.
  
app.config.globalProperties.$config = window.__INITIAL_STATE__;
const config = window.__INITIAL_STATE__;
// Provide the global configuration
app.provide('config', config); 

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('font-awesome-layers', FontAwesomeLayers);
app.component('font-awesome-layers-text', FontAwesomeLayersText);

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

//Datepicker 
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
app.component('datepicker', VueDatePicker);

// Tooltip
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

app.use(FloatingVue, {
    themes: {
        tooltip: {
            // Default position offset (px)
            offset: 0,
            // Default placement
            placement: 'left',
            // Default container
            container: 'div',
            // other options
            showTriggers: ['hover', 'touch', 'focus'],  
            hideTriggers: events => events.filter(e => ['hover', 'clickOutside'].includes(e)),
            touchHold: true,
            autoHide: false,
            preventOverflow: false,
            delay: { show: 0, hide: 0 },
        },
    }});

// Lazy Image
import VLazyImage from "v-lazy-image";
app.component('VLazyImage', VLazyImage);

// EventBus configuration
import { EventBus } from './bus';
app.config.globalProperties.$bus = EventBus;

import IdleVue from 'vue-idle';
const idleOptions = {
  eventEmitter: EventBus,
  idleTime: window.idleTimeout
};
app.use(IdleVue, idleOptions);

// Pulte Packages
import {
    Background,
    Banner,
    FamilyOfBrands,
    Footer,
    FormResultMessage,
    HaveQuestions,
    Idle,
    Modal,
    NavBar,
    NavLink,
    Numeric
} from '@pulte/pulte-myloan-npm';

app.component('background', Background);
app.component('pulte-banner', Banner);
app.component('family-of-brands', FamilyOfBrands);
app.component('pulte-footer', Footer);
app.component('form-result-message', FormResultMessage);
app.component('have-questions', HaveQuestions);
app.component('idle', Idle);
app.component('modal', Modal);
app.component('nav-bar', NavBar);
app.component('nav-link', NavLink);
app.component('numeric', Numeric);

app.config.globalProperties.$filters = {
    bytesToMegabytes(value) {
        if (value) {
            return Math.trunc(value / 1024 / 1024);
        }
    }
};
import {LoaderOverlay} from '@pulte/pulte-myloan-npm';
app.component('loader-overlay', LoaderOverlay);
// End Pulte Packages

import ScrollAnchor from './components/ScrollAnchor.vue';
app.component('scroll-anchor', ScrollAnchor);

import Lottie from './components/Lottie';
app.component('lottie', Lottie);

app.config.productionTip = false;

import { VueReCaptcha } from 'vue-recaptcha-v3';
app.use(VueReCaptcha, { siteKey: window.recaptchaOptions.recaptchaKey });

import LoginForm from './components/forms/LoginForm';
app.component('login-form', LoginForm);

import vueVimeoPlayer from 'vue-vimeo-player';
app.use(vueVimeoPlayer);

app.use(router);
app.use(store);
app.mount('#app');